// extracted by mini-css-extract-plugin
export default {"cardTable":"CardTable_cardTable__YntZg","cardTableTitle":"CardTable_cardTableTitle__VN2RS","cardTableValue":"CardTable_cardTableValue__3m+qp"};